// src/api/users.js
import axios from 'axios';

export const fetchUsers = async ({ token, limit, nextToken, excludeDomains }) => {
  try {
    console.log('Fetching users with params:', { limit, nextToken, excludeDomains }); // Debugging line
    const apiUrl = `${process.env.REACT_APP_BACKEND_URL}/admin/users`;

    const params = {
      limit,
    };

    if (nextToken) {
      params.nextToken = nextToken;
    }

    if (excludeDomains) {
      params.excludeDomains = excludeDomains;
    }

    const response = await axios.get(apiUrl, {
      headers: {
        authorizationToken: token,
      },
      params,
    });

    if (response.status !== 200) {
      throw new Error("Failed to fetch users");
    }
    return response.data;
  } catch (error) {
    console.error('Error in fetchUsers:', error); // Debugging line
    throw error;
  }
};
